<template>
  <transition-group
    tag="ul"
    :class="[
      'el-upload-list',
      'el-upload-list--' + listType,
      { 'is-disabled': disabled }
    ]"
    name="el-list"
  >
    <li
      v-for="file in files"
      :class="['el-upload-list__item sy-upload-list__item', 'is-' + file.status, focusing ? 'focusing' : '']"
      :key="file.uid || file"
      tabindex="0"
      @keydown.delete="!disabled && $emit('remove', file)"
      @focus="focusing = true"
      @blur="focusing = false"
      @click="focusing = false"
    >
      <!-- 附件名称 -->
      <a class="el-upload-list__item-name font-color-hover-primary" @click="handleClick(file)" v-if="listType !== 'picture-card'" :title="file.name">
        <span v-if="listType === 'text'">
          <i v-if="file.status === 'ready' || file.status == 'uploading'" class="el-icon-loading"></i>
          <span
            v-else
            class="sy-upload-list__item-status-success"
            :data-key="GetFileIcon(file._fileType)"
            :style="{
              'backgroundPosition': file._fileType && GetFileIcon(file._fileType)
            }"
          ></span>
          <i class="el-icon-download"></i>
          <!-- <i v-else class="sy-upload-list__item-status-success" :class="{
            'el-icon-upload-success': true,
            'el-icon-circle-check': listType === 'text'
          }"></i> -->
        </span>
        {{file.name}}
      </a>
      <!-- 图片展示 -->
      <img
        class="el-upload-list__item-thumbnail"
        v-if="file.status !== 'uploading' && file.status !== 'ready' && ['picture-card', 'picture'].indexOf(listType) > -1"
        :src="file.url" alt=""
      >
      <!-- 文件上传成功状态 图标 -->
      <!-- <label class="el-upload-list__item-status-label sy-upload-list__item-status" v-if="listType === 'text'">
        <i v-if="file.status === 'ready' || file.status == 'uploading'" class="el-icon-loading"></i>
        <i v-else :class="{
          'el-icon-upload-success': true,
          'el-icon-circle-check': listType === 'text'
        }"></i>
      </label> -->

      <i class="el-icon-close sy-upload-list__item-status-close" v-if="!disabled" @click="$emit('remove', file)"></i>
      <i class="el-icon-close-tip" v-if="!disabled"></i> <!--因为close按钮只在li:focus的时候 display, li blur后就不存在了，所以键盘导航时永远无法 focus到 close按钮上-->
      
      <!-- 文件类型 上传进度 -->
      <el-progress
        v-if="file.status == 'uploading' && listType === 'text'"
        type="line"
        stroke-width="2"
        :percentage="parsePercentage(file.percentage)">
      </el-progress>

      <!-- 图片类型 上传进度 -->
      <template v-if="listType === 'picture-card'">
        <el-progress
          v-if="file.status === 'ready'"
          class="sy-upload_picture-card-ready"
          type="circle"
          stroke-width="6"
          :percentage="0"
          :show-text="false"
        ></el-progress>
        <el-progress
          v-else-if="file.status == 'uploading'"
          class="sy-upload_picture-card-uplading"
          type="circle"
          stroke-width="6"
          :show-text="false"
          :percentage="parsePercentage(file.percentage)"
        ></el-progress>
        <span class="sy-upload_picture-card-status-tip" v-if="file.status === 'ready'">{{pageText.uploadReady}}</span>
        <span class="sy-upload_picture-card-status-tip" v-else-if="file.status == 'uploading'">{{pageText.awaiting}}</span>
      </template>
      
      <!-- 图片类型上传成功  -->
      <span class="el-upload-list__item-actions" v-if="listType === 'picture-card'">
        <span
          class="el-upload-list__item-preview"
          v-if="handlePreview && listType === 'picture-card' && file.status === 'success'"
          @click="handleClick(file)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
          v-if="!disabled && file.status !== 'uploading'"
          class="el-upload-list__item-delete"
          @click="$emit('remove', file)"
        >
          <i class="el-icon-delete"></i>
        </span>
        <span
          v-if="file.status === 'uploading'"
          class="el-upload-list__item-delete"
          @click="$emit('cancel', file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </li>
  </transition-group>
</template>

<script>
  import i18n from './i18n.js'
  import {GetFileIcon} from './common/constans.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    props: {
      files: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      },
      handlePreview: Function,
      listType: String
    },
    watch: {
      files: {
        immediate: true,
        handler (val) {
          if (val) {
            val.forEach(v => {
              const name = v.originalName || v.name
              if (name) {
                let arr = name.split('.')
                v._fileType = arr[arr.length - 1]
                this.$set(v, '_fileType', arr[arr.length - 1])
              }
            })
          }
        }
      }
    },
    data () {
      return {
        GetFileIcon,
        focusing: false,
        pageText
      }
    },
    methods: {
      parsePercentage (val) {
        return parseInt(val, 10)
      },
      handleClick (file) {
        this.handlePreview && this.handlePreview(file)
      }
    }
  }
</script>

<style lang="scss" scoped>
.el-upload-list--picture-card{
  line-height: 1;
  .el-upload-list__item {
    width: 62px;
    height: 62px;
    border-radius: 0px;
    overflow: hidden;
    .el-upload-list__item-actions {
      line-height: 60px;
    }
  }
}

.el-upload-list__item-thumbnail {
  width: 100%;
  object-fit: contain;
}

.el-upload-list--picture-card .el-upload-list__item-actions {
  font-size: 12px;
}
.el-upload-list--picture-card .el-upload-list__item-actions span+span {
  margin-left: 10px;
}
.el-upload-list--picture-card .el-progress {
  top: 30%;
  width: 20px;
  ::v-deep .el-progress-circle {
    width: 20px !important;
    height: 20px !important;
  }
}
// 图片 等待上传
.sy-upload_picture-card-status-tip {
  font-size: 12px;
  color: #BBBBBB;
  letter-spacing: 0;
  line-height: 16px;
  font-weight: 400;
  position: absolute;
  top: 50%;
  left: 0px;
  text-align: center;
  width: 60px;
}

.el-upload-list--picture-card  .el-upload-list__item {
  overflow: hidden;
  // 编辑页面回显 图片字段点击编辑后，在编辑页会出现弹框虚影
  transition: none;
}
// 文件上传状态
.el-upload-list__item-name {
  width: calc(100% - 20px);
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  padding-left: 0px;
  margin-right: 0px;
  .sy-upload-list__item-status-success {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
    background: url($img-url + '163663639174472357.png') no-repeat;
    background-size: 50px;
  }
  .el-icon-download {
    display: none;
  }
  &:hover {
    background: #F9F9F9;
    border-radius: 14px;
    .el-icon-download {
      display: inline-block;
      color: inherit;
    }
    .sy-upload-list__item-status-success {
      display: none;
    }
  }
}
.el-upload-list--text .sy-upload-list__item {
  padding-left: 8px;
  &:hover {
    border-radius: 14px;
    background: #F9F9F9;
  }
}
.el-upload-list--picture-card .sy-upload-list__item {
  padding-left: 0px;
  &:hover {
    border-radius: 0px;
    background: transparent;
  }
}
// 附件 上传中
.el-upload-list--text {
  .el-upload-list__item ::v-deep .el-progress .el-progress__text {
    right: 8px;
  }
}
</style>
